module.exports = __webpack_public_path__ + "static/media/payu.93c87159.png";